import * as types from './constants';

export const showExitPopup = target => ({
  type: types.UI_SHOW_EXIT_POPUP,
  target,
});

export const hideExitPopup = () => ({
  type: types.UI_HIDE_EXIT_POPUP,
});

export const changeCurrentStep = visibleStep => ({
  type: types.UI_CHANGE_CURRENT_STEP,
  visibleStep,
});

export const toggleOlxProPopup = () => ({
  type: types.UI_TOGGLE_OLX_PRO_POPUP,
});

export const toggleLoader = () => ({
  type: types.UI_TOGGLE_LOADING,
});

export const selectCharacteristic = characteristicIndex => ({
  type: types.UI_SELECTED_CHARACTERISTIC,
  selectedCharacteristic: characteristicIndex,
});

export const showModal = () => ({
  type: types.UI_SHOW_MODAL,
});

export const hideModal = () => ({
  type: types.UI_HIDE_MODAL,
});

export default {
  showExitPopup,
  hideExitPopup,
  toggleOlxProPopup,
  toggleLoader,
  selectCharacteristic,
  showModal,
  hideModal,
};
